import { render, staticRenderFns } from "./TermsOfServiceRU.vue?vue&type=template&id=402857fb&"
import script from "./TermsOfServiceRU.vue?vue&type=script&lang=js&"
export * from "./TermsOfServiceRU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports